const bookInformation = [
  {
    id: "1",
    title: "Agile Testing: A Practical Guide for Testers and Agile Teams",
    imageUrl: "agile_testing.png",
    author: "Janet Gregory & Lisa Crispin",
    pages: 533,
    description:
      "Two of the industry’s most experienced agile testing practitioners and consultants, Lisa Crispin and Janet Gregory, have teamed up to bring you the definitive answers to these questions and many others. In Agile Testing, Crispin and Gregory define agile testing and illustrate the tester’s role with examples from real agile teams. They teach you how to use the agile testing quadrants to identify what testing is needed, who should do it, and what tools might help. The book chronicles an agile software development iteration from the viewpoint of a tester and explains the seven key success factors of agile testing.",
  },
  {
    id: "2",
    title: "Agile Testing Condensed: A Brief Introduction",
    imageUrl: "agile_testing_condensed.png",
    author: "Janet Gregory & Lisa Crispin",
    pages: 113,
    description:
      "Agile Testing Condensed presents a concise, easy-to-read overview of how to succeed with testing and build a quality culture in an agile context.",
  },
  {
    id: "3",
    title: "Perfect Software: And Other Illusions about Testing",
    imageUrl: "perfect_software.png",
    author: "Gerald Weinberg",
    pages: 182,
    description:
      "Jerry Weinberg, author of The Psychology of Computer Programming and more than forty nonfiction books, sets out to disprove destructive notions about testing and testers in Perfect Software And Other Illusions About Testing. With a blend of wit, storytelling, and jaw-dropping insight that has won him fans around the world, Weinberg deftly separates what is expected, significant, and possible in software testing. He destroys fallacies and steers readers clear of common mistakes",
  },
  {
    id: "4",
    title: "Lessons Learned in Software Testing: A Context-Driven Approach",
    imageUrl: "lessons_learned.png",
    author: "Cem Kaner, James Bach, et al",
    pages: 286,
    description:
      "In this groundbreaking new book, authors have compiled 293 pieces of experience-tested advice for you to put to work in your testing projects. They reveal insights on how to do the job well, how to manage it, and how to steer clear of common misunderstandings in software testing. Each lesson is an assertion related to software testing, followed by an explanation or example that shows you the how, when, and why of the testing lesson.",
  },
  {
    id: "5",
    title:
      "Explore It!: Reduce Risk and Increase Confidence with Exploratory Testing",
    imageUrl: "explore_it.png",
    author: "Elisabeth Hendrickson",
    pages: 162,
    description:
      "Uncover surprises, risks, and potentially serious bugs with exploratory testing. Rather than designing all tests in advance, explorers design and execute small, rapid experiments. In this book, you'll learn how to analyze software to discover key points of vulnerability, how to design experiments on the fly, how to hone your observation skills, and how to focus your efforts.",
  },
  {
    id: "6",
    title:
      "Unit Testing Principles, Practices, and Patterns: Effective testing styles, ...",
    imageUrl: "unit_testing.png",
    author: "Vladimir Khorikov",
    pages: 304,
    description:
      "Unit Testing: Principles, Patterns and Practices shows you how to refine your existing unit tests by implementing modern best practices. You’ll learn to spot which tests are performing, which need refactoring, and which need to be deleted entirely! Upgrade your testing suite with new testing styles, good patterns, and reliable automated testing.",
  },
];

export default class BookData {
  getBooksByTitle(title) {
    return bookInformation.filter((book) =>
      book.title.toLowerCase().includes(title.toLowerCase())
    );
  }

  getBookById(id) {
    return bookInformation.filter((book) => book.id === id);
  }
}
